import React, { useState } from 'react';
import { englishCodas, englishFirstOnsets, englishLastCodas, englishNuclei, englishOnsets, englishOtherCodas, englishOtherOnsets, englishSyllableCounts } from '../../phonotactics/englishSyllableStats';
import { japaneseSyllableCounts, japaneseFirstOnsets, japaneseOtherOnsets, japaneseNuclei, japaneseLastCodas, japaneseOtherCodas, japaneseOnsets, japaneseCodas } from '../../phonotactics/japaneseSyllableStats';
import { spanishCodas, spanishFirstOnsets, spanishLastCodas, spanishNuclei, spanishOnsets, spanishOtherCodas, spanishOtherOnsets, spanishSyllableCounts } from '../../phonotactics/spanishSyllableStats';
import { PhonotacticsInput, WordGenerator } from '../../phonotactics/wordGenerator';
import { ipaToEnglish } from '../../ruleSets/ipaToEnglish';
import { ipaToSpanish } from '../../ruleSets/ipaToSpanish';
import { RulesRunner } from '../../rules/rulesRunner';
import { ChoiceList } from '../widgets/ChoiceList';
import { ShowPhonemes } from '../customRules/ShowPhonemes';
import { EditPhonotactics } from './EditPhonotactics';
import { MakeUpWord } from './MakeUpWord';
import { PhonotacticsTable, PhonotacticsTableProps } from './PhonotacticsTable';
import { EditSpeakOptions } from '../EditSpeakOptions';

/** phonotactics has to do with a language's choice of how to restrict phoneme combinations */
export function PhonotacticsArea() {
  const [language, setLanguage] = useState('English');
  const [forLengua, setForLengua] = useState<PhonotacticsInput & PhonotacticsTableProps>(languageStats['English']);
  const [forCustom, setForCustom] = useState<PhonotacticsInput>(languageStats['Spanish']);
  const [forMake, setForMake] = useState<PhonotacticsInput>(languageStats['English']);
  const [fromIpa, setFromIpa] = useState<RulesRunner | undefined>(languageStats['English'].fromIpa);
  const items = Object.keys(languageStats);

  function changeLanguage(l: string) {
    setLanguage(l);
    setForLengua(languageStats[l]);
    setForMake(languageStats[l]);
    setFromIpa(languageStats[l].fromIpa);
  }

  function changeCustom(p: PhonotacticsInput) {
    setForCustom(p);
    setForMake(p);
  }

  return (
    <div>
      <h2>Phonotactics</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'auto 30%' }}>
        <div style={{ width: 700 }}>
          <ChoiceList items={items} selectedItem={language} onSelect={changeLanguage} />
          <PhonotacticsTable onsetToCount={forLengua.onsetToCount} nucleusToCount={forLengua.nucleusToCount} codaToCount={forLengua.codaToCount} />
          <hr />
          <MakeUpWord wordMaker={new WordGenerator(forMake)} fromIpa={fromIpa} />
          <hr />
          <EditPhonotactics onChange={changeCustom} phonotacticsFallback={forCustom} />
        </div>
        <div>
          <ShowPhonemes />
        </div>
      </div>
      <hr />
      <EditSpeakOptions />
      <br /><br />
    </div>
  );
}

interface FromIpa {
  readonly fromIpa?: RulesRunner;
}

const languageStats: Record<string, PhonotacticsInput & PhonotacticsTableProps & FromIpa> = {
  English: {
    syllableCounts: englishSyllableCounts,
    stressSyllable: 1,

    firstOnsets: englishFirstOnsets,
    otherOnsets: englishOtherOnsets,
    nucleus: englishNuclei,
    lastCodas: englishLastCodas,
    otherCodas: englishOtherCodas,

    onsetToCount: englishOnsets,
    nucleusToCount: englishNuclei,
    codaToCount: englishCodas,

    fromIpa: new RulesRunner(ipaToEnglish),
  },
  Spanish: {
    syllableCounts: spanishSyllableCounts,
    stressSyllable: 'spanish',

    firstOnsets: spanishFirstOnsets,
    otherOnsets: spanishOtherOnsets,
    nucleus: spanishNuclei,
    lastCodas: spanishLastCodas,
    otherCodas: spanishOtherCodas,

    onsetToCount: spanishOnsets,
    nucleusToCount: spanishNuclei,
    codaToCount: spanishCodas,

    fromIpa: new RulesRunner(ipaToSpanish),
  },
  Japanese: {
    syllableCounts: japaneseSyllableCounts,
    stressSyllable: 0,

    firstOnsets: japaneseFirstOnsets,
    otherOnsets: japaneseOtherOnsets,
    nucleus: japaneseNuclei,
    lastCodas: japaneseLastCodas,
    otherCodas: japaneseOtherCodas,

    onsetToCount: japaneseOnsets,
    nucleusToCount: japaneseNuclei,
    codaToCount: japaneseCodas,
  },
}
